var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _ellipse, _rect2, _path8, _ellipse2, _g, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _rect3, _ellipse3, _rect4, _path25, _ellipse4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutomationbremove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.3;fill:url(#SVGID_1_);enable-background:new    ;}\r\n\t.st1{opacity:0.89;}\r\n\t.st2{fill:url(#SVGID_00000026134702296901866180000004756322146531406012_);}\r\n\t.st3{opacity:0.86;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st4{opacity:0.5;}\r\n\t.st5{opacity:0.5;fill:url(#SVGID_00000171693746815309949680000002673009963810940860_);enable-background:new    ;}\r\n\t.st6{opacity:0.47;fill:url(#SVGID_00000052067976421308234820000007771863682306449024_);enable-background:new    ;}\r\n\t.st7{opacity:0.5;fill:url(#SVGID_00000130611703377369245250000013685702230715287682_);enable-background:new    ;}\r\n\t.st8{fill:url(#SVGID_00000005265775113919513780000013433532138888414338_);}\r\n\t.st9{opacity:0.54;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st10{fill:url(#SVGID_00000168084596154888919900000000606727085493233286_);}\r\n\t.st11{fill:url(#SVGID_00000136401225514224782580000014104291091853304245_);}\r\n\t.st12{fill:url(#SVGID_00000083087672939284180350000002874357394804565181_);}\r\n\t.st13{fill:url(#SVGID_00000018920642418124178380000006128680102315873196_);}\r\n\t.st14{fill:url(#SVGID_00000013160261073288648250000007972971390703628452_);}\r\n\t.st15{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st16{fill:url(#SVGID_00000111193494374872478320000008132895011171348914_);}\r\n\t.st17{fill:#FFFFFF;}\r\n\t.st18{fill:url(#SVGID_00000111190244118142452250000016898067661454862485_);}\r\n\t.st19{fill:url(#SVGID_00000085233833901834998930000010111414105148779654_);}\r\n\t.st20{fill:url(#SVGID_00000113337778503381579810000010819178817642224517_);}\r\n\t.st21{fill:url(#SVGID_00000008113229268302282070000017427737582643482792_);}\r\n\t.st22{fill:url(#SVGID_00000134238370884892396660000012799197809345653126_);}\r\n\t.st23{fill:url(#SVGID_00000158734743044200811880000005711861352786787207_);}\r\n\t.st24{fill:url(#SVGID_00000160906182129369165510000014498774383321244589_);}\r\n\t.st25{fill:url(#SVGID_00000171678336460886043270000008517869737729930391_);}\r\n\t.st26{fill:url(#SVGID_00000064342571128355260710000001131296555672382360_);}\r\n\t.st27{fill:url(#SVGID_00000158028006935616819990000009375504961479746217_);}\r\n\t.st28{opacity:0.39;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st29{fill:url(#SVGID_00000129173638509683392000000004093745576927697309_);}\r\n\t.st30{fill:url(#SVGID_00000165228004984495224570000001301875960563393155_);}\r\n\t.st31{fill:url(#SVGID_00000103233981318284501490000005333865697655141296_);}\r\n\t.st32{fill:url(#SVGID_00000005954437174409003080000012392559423571875977_);}\r\n\t.st33{fill:url(#SVGID_00000059283287254138421510000016956644663791083696_);}\r\n\t.st34{fill:url(#SVGID_00000152256759224130437350000012560571179154491290_);}\r\n\t.st35{fill:url(#SVGID_00000131367075773694536620000005703739444743675837_);}\r\n\t.st36{fill:url(#SVGID_00000007417425299083370920000000395790757134282174_);}\r\n\t.st37{fill:url(#SVGID_00000164498724869284167440000001163558094300476071_);}\r\n\t.st38{fill:url(#SVGID_00000156569389544587162650000007138341929181507490_);}\r\n\t.st39{fill:url(#SVGID_00000145766921059519789940000006588358899596401024_);}\r\n\t.st40{fill:url(#SVGID_00000101098403520208510730000007333327921263095467_);}\r\n\t.st41{fill:url(#SVGID_00000065757444774216841450000018357500964423578526_);}\r\n\t.st42{fill:url(#SVGID_00000088117920739888862140000013401504010627526073_);}\r\n\t.st43{fill:url(#SVGID_00000023967598777438396220000015467976065414000544_);}\r\n\t.st44{fill:url(#SVGID_00000120546520676928566400000003750680176963539601_);}\r\n\t.st45{fill:url(#SVGID_00000056408112245642401530000009664084353450585773_);}\r\n\t.st46{fill:url(#SVGID_00000103981578364140376340000007176101506863763843_);}\r\n\t.st47{fill:url(#SVGID_00000094620559474653357730000018393736402644636310_);}\r\n\t.st48{fill:url(#SVGID_00000117636533547580430850000007985899866963164825_);}\r\n\t.st49{fill:url(#SVGID_00000150072890618365501600000010938715282983674756_);}\r\n\t.st50{fill:url(#SVGID_00000101105062046767730830000018009311704506828192_);}\r\n\t.st51{fill:url(#SVGID_00000168082431755653483660000003522026295874982311_);}\r\n\t.st52{fill:url(#SVGID_00000155114504021443548020000005314831410444469410_);}\r\n\t.st53{fill:url(#SVGID_00000036962397074975961040000002061256449366902188_);}\r\n\t.st54{fill:url(#SVGID_00000088127357390020849830000010346009516792006576_);}\r\n\t.st55{fill:url(#SVGID_00000008123944034028382220000000378793824790061449_);}\r\n\t.st56{fill:url(#SVGID_00000068649863217678827430000001890232268732686234_);}\r\n\t.st57{fill:url(#SVGID_00000021121811318740519750000010974774618521682618_);}\r\n\t.st58{fill:url(#SVGID_00000032606561055650262140000014195541660629566612_);}\r\n\t.st59{fill:url(#SVGID_00000059309402183906788080000003001668875788015274_);}\r\n\t.st60{fill:url(#SVGID_00000079487472212864145650000000132700588869004194_);}\r\n\t.st61{fill:url(#SVGID_00000089561762075712990770000015724074979965899145_);}\r\n\t.st62{fill:url(#SVGID_00000101098054693160934170000001828687291251694502_);}\r\n\t.st63{fill:url(#SVGID_00000061458582372862525900000006252887459008503208_);}\r\n\t.st64{fill:url(#SVGID_00000132806658460322429980000005762696859645494164_);}\r\n\t.st65{fill:url(#SVGID_00000015344240069368661710000009681809341092841109_);}\r\n\t.st66{fill:url(#SVGID_00000129176400451080640120000001322151598485837969_);}\r\n\t.st67{fill:url(#SVGID_00000126310009371812185350000003303178632841495470_);}\r\n\t.st68{fill:url(#SVGID_00000172406823469511703520000008058263454392719505_);}\r\n\t.st69{fill:url(#SVGID_00000021096673941871212790000014144870792196768396_);}\r\n\t.st70{fill:url(#SVGID_00000144310255886777582660000004855672913167427985_);}\r\n\t.st71{fill:url(#SVGID_00000132054146961084326400000006476647034540690574_);}\r\n\t.st72{fill:url(#SVGID_00000092447164530869939920000012687023961949079459_);}\r\n\t.st73{fill:url(#SVGID_00000152971196739329875740000017363879614919691181_);}\r\n\t.st74{fill:url(#SVGID_00000166677028325767085970000003024203062943625402_);}\r\n\t.st75{fill:url(#SVGID_00000006686765902331137460000005525628354462517419_);}\r\n\t.st76{fill:url(#SVGID_00000172400735914590930530000014014038715512138885_);}\r\n\t.st77{fill:url(#SVGID_00000008116651080691544470000008539098738768149169_);}\r\n\t.st78{fill:url(#SVGID_00000001657276393888919600000004436976315505016511_);}\r\n\t.st79{fill:url(#SVGID_00000030461401284597737190000004427781146805241509_);}\r\n\t.st80{fill:url(#SVGID_00000178182438307083299620000016219814322127339950_);}\r\n\t.st81{fill:url(#SVGID_00000080193469932251240680000010899450535698772405_);}\r\n\t.st82{fill:url(#SVGID_00000147939392443963532400000005458725263303279009_);}\r\n\t.st83{fill:url(#SVGID_00000107580682322369328580000002721700556667423391_);}\r\n\t.st84{fill:url(#SVGID_00000036219413709176606170000007522063755572611005_);}\r\n\t.st85{fill:url(#SVGID_00000071534708316563369010000009449051051908318355_);}\r\n\t.st86{fill:url(#SVGID_00000127017258467009587570000017540566023445770116_);}\r\n\t.st87{fill:url(#SVGID_00000065064751115107161350000001971122285401724559_);}\r\n\t.st88{fill:url(#SVGID_00000183237878894629822050000016500113638008233407_);}\r\n\t.st89{fill:url(#SVGID_00000132775133898861936880000001720408621751099833_);}\r\n\t.st90{fill:url(#SVGID_00000056395936077852298220000002649896920566106801_);}\r\n\t.st91{fill:url(#SVGID_00000116205072886232696050000000915195811679149707_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3613.0625,
    y1: -371.8977,
    x2: 1121.0726,
    y2: 2722.998,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2927.8,2861.1c-57.3,60.2-111.4,99.1-154.2,129.8c-503.2,360.8-1098.5,255.6-1225.1,230 c-186.8-37.9-548-111.2-809.2-418.2C344.3,2338.4,405.9,1606.9,712.3,1124c56-88.3,352.1-578.6,953.9-657.2 c364.2-47.6,788.7,48.4,1096.1,305.8C3407.7,1312.9,3361.7,2404.6,2927.8,2861.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121986638295695843020000004113082546497083009_",
    gradientUnits: "userSpaceOnUse",
    x1: 2550.3533,
    y1: -1847.2892,
    x2: 3941.6499,
    y2: -891.1561,
    gradientTransform: "matrix(-0.2052 -0.9787 0.9787 -0.2052 2790.8982 4597.0522)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121986638295695843020000004113082546497083009_)"
    },
    d: "M836.5,2532.3 c0,0,252.3-704.3,199.3-1066.4c-47.3-323.2-144.5-773.6-164.8-866.7c-1.4-6.4-9.9-7.8-13.2-2.2 c-55.4,91.3-329.4,588.7-154.1,1234.2C897.9,2546.7,836.5,2532.3,836.5,2532.3z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M832.5,828.6c-4.8,105.6-4.4,211.6-1.2,317.3c3.2,105.8,10.2,211.4,21.2,316.6c5.6,52.6,12.3,105.1,20,157.3 c8,52.3,17.3,104.3,27.8,156.1c10.9,51.7,23.2,103.1,37.4,153.9c14.5,50.8,30.8,101,49.5,150.3l0,0.1c1.3,3.5-0.4,7.4-3.9,8.7 c-3.5,1.3-7.4-0.4-8.7-3.9l0,0c-18.5-49.9-34.7-100.5-49.1-151.7c-14-51.3-26-103-36.8-155c-10.3-52.1-19.4-104.4-27.1-156.8 c-7.5-52.5-14-105.2-19.3-157.9c-10.4-105.6-16.9-211.4-19.6-317.4c-2.7-106-2.4-212,2.9-318c0.1-1.9,1.7-3.4,3.7-3.3 C831.1,825,832.6,826.6,832.5,828.6L832.5,828.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119087161246340273810000006989876778562944423_",
    gradientUnits: "userSpaceOnUse",
    x1: 1282.4301,
    y1: 2437.6899,
    x2: 1971.53,
    y2: 2437.6899,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000119087161246340273810000006989876778562944423_)",
      enableBackground: "new"
    },
    points: " 1803.9,956.4 1459.5,952.3 1282.4,1273.2 1459.5,1592.3 1803.9,1584.9 1971.5,1269.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150088379269030800310000003201116318998229925_",
    gradientUnits: "userSpaceOnUse",
    x1: 1863.0699,
    y1: 2088.79,
    x2: 2511.8899,
    y2: 2088.79,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.47,
      fill: "url(#SVGID_00000150088379269030800310000003201116318998229925_)",
      enableBackground: "new"
    },
    points: " 2354,1309.6 2029.6,1311.9 1863.1,1626.3 2029.6,1932.8 2354,1919.6 2511.9,1610.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168116514718918666760000014513221920298845357_",
    gradientUnits: "userSpaceOnUse",
    x1: 1863.0699,
    y1: 2794.01,
    x2: 2511.8899,
    y2: 2794.01,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000168116514718918666760000014513221920298845357_)",
      enableBackground: "new"
    },
    points: " 2354,615.7 2029.6,605.5 1863.1,913.6 2029.6,1226.4 2354,1225.7 2511.9,922.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067924011251154124900000009687789374265453467_",
    gradientUnits: "userSpaceOnUse",
    x1: 649.3517,
    y1: 783.2714,
    x2: 1063.506,
    y2: 2687.3677,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067924011251154124900000009687789374265453467_)"
    },
    d: "M574.9,1212.3 c196.1,177.7,659.2,717.5,596,1809.7c0,0-840.4-741.1-698.8-1772C478.9,1200.5,538,1178.8,574.9,1212.3z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M638.6,1503.2c2.8,28.4,6.5,57.1,10.5,85.7c4,28.6,8.5,57.1,13.3,85.6c9.6,56.9,20.6,113.7,32.9,170.1 c24.7,112.9,54.3,224.7,90.2,334.6c8.8,27.5,18.4,54.8,27.9,82.1l15,40.7c2.5,6.8,4.9,13.6,7.6,20.3l7.9,20.2l7.9,20.2 c2.6,6.7,5.3,13.5,8.1,20.1l16.7,40c5.6,13.3,11.7,26.4,17.5,39.6l8.8,19.8c3,6.6,6.2,13.1,9.3,19.6l18.7,39.1l19.7,38.6 c6.4,13,13.5,25.6,20.4,38.3l10.4,19l5.2,9.5l5.5,9.4l21.9,37.4c3.6,6.3,7.5,12.4,11.4,18.5l11.6,18.4l11.6,18.4 c3.8,6.1,8.1,12,12.1,18l24.4,35.9l0,0.1c0.6,0.8,0.3,2-0.5,2.5c-0.8,0.6-1.9,0.4-2.5-0.5l-25-35.6c-4.1-6-8.4-11.8-12.4-17.9 l-11.9-18.2l-11.9-18.2c-3.9-6.1-8-12.1-11.7-18.4l-22.5-37.2l-5.6-9.3l-5.3-9.5l-10.7-18.9c-7.1-12.6-14.4-25.2-21-38.1 l-20.3-38.5l-19.3-39c-3.2-6.5-6.5-13-9.6-19.5l-9.2-19.7c-6-13.2-12.3-26.3-18.2-39.6l-17.4-39.9c-3-6.6-5.7-13.3-8.4-20.1 l-8.2-20.1l-8.2-20.1c-2.7-6.7-5.2-13.5-7.9-20.3l-15.6-40.6c-9.9-27.3-20-54.5-29.2-82c-37.6-109.8-68.9-221.8-95.4-334.8 c-13.2-56.6-25-113.4-35.5-170.6c-5.2-28.6-10.1-57.2-14.6-85.9c-4.4-28.8-8.6-57.4-11.9-86.6c-0.7-6.4,3.9-12.2,10.3-12.9 c6.4-0.7,12.2,3.9,12.9,10.3c0,0,0,0.1,0,0.1L638.6,1503.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026147663691649593450000001907176813064478386_",
    gradientUnits: "userSpaceOnUse",
    x1: -19.5659,
    y1: -2247.8506,
    x2: 1776.2615,
    y2: -1013.7141,
    gradientTransform: "matrix(0.151 -0.9885 0.9885 0.151 3848.6416 2949.627)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026147663691649593450000001907176813064478386_)"
    },
    d: "M2055.6,2863.2 c0,0,623.7-737.2,723.5-1198.9c89.1-412.1,175.5-1000.5,193-1122.3c1.2-8.3-8.4-13.9-15-8.7 c-108.3,85.3-664.6,562.6-744.8,1422.2C2123.4,2908.5,2055.6,2863.2,2055.6,2863.2z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2820.9,801.5c-27,62.7-52.1,126.3-76.2,190.1c-24.1,63.9-47.1,128.2-69.1,192.9 c-21.9,64.7-42.9,129.7-62.6,195.1c-19.6,65.4-38.1,131.2-55.4,197.2c-17.1,66.1-32.8,132.6-47.1,199.3 c-14.1,66.8-26.4,133.9-37.2,201.3c-10.2,67.5-18.7,135.2-24.6,203.1c-5.5,68-8.5,136.1-8.4,204.2v0.1c0,3.7-3,6.7-6.7,6.8 s-6.7-3-6.8-6.7v0c0.1-68.6,3.4-137.1,9.2-205.4c6.3-68.2,15-136.2,25.5-203.9c11.1-67.6,23.7-134.9,38.1-201.8 c14.6-66.9,30.6-133.4,48-199.6c17.6-66.1,36.4-131.9,56.3-197.4c19.9-65.4,41.2-130.5,63.4-195.2c22.2-64.7,45.6-129,70-192.9 c24.5-63.9,49.8-127.4,77.1-190.2c0.8-1.8,2.8-2.6,4.6-1.8S2821.6,799.7,2820.9,801.5L2820.9,801.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129911048042140961210000017933535789886162848_",
    gradientUnits: "userSpaceOnUse",
    x1: -453.6897,
    y1: -1862.7135,
    x2: 1084.5197,
    y2: -805.6185,
    gradientTransform: "matrix(0.2474 -0.9689 0.9689 0.2474 3838.4824 2680.3523)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129911048042140961210000017933535789886162848_)"
    },
    d: "M2270,2894.6 c0,0,593.7-575.9,717.6-961.1c110.6-343.8,233.8-838.1,259-940.4c1.7-7-6-12.5-12.1-8.7c-99.5,63.6-613.9,423.7-754.6,1149.7 C2323.9,2938.9,2270,2894.6,2270,2894.6z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3096.2,1201.9c-28.2,51.1-55,103.3-80.9,155.7c-25.9,52.5-50.9,105.3-75.1,158.6 c-48.4,106.5-93,214.8-133.5,324.5c-20.1,54.9-39,110.2-56.9,165.9c-17.6,55.8-33.8,111.9-48.6,168.5 c-14.4,56.6-27.2,113.6-38,171c-10.4,57.5-18.7,115.2-24.2,173.3l0,0.1c-0.4,3.7-3.6,6.4-7.4,6.1c-3.7-0.4-6.4-3.6-6.1-7.4v0 c5.9-58.5,14.5-116.6,25.2-174.4c11.1-57.7,24.3-114.9,39-171.7c15.1-56.7,31.6-113,49.5-168.8c18.1-55.8,37.4-111.2,57.8-166.1 c41.1-109.8,86.3-218,135.2-324.5c24.4-53.3,49.8-106.1,75.9-158.5c26.3-52.4,53.2-104.4,81.8-155.6c0.9-1.7,3.1-2.3,4.8-1.3 C3096.6,1198,3097.2,1200.2,3096.2,1201.9L3096.2,1201.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168807273283149945470000012964374496046878374_",
    gradientUnits: "userSpaceOnUse",
    x1: 1660.5627,
    y1: 2574.6008,
    x2: 1690.8679,
    y2: 569.4844,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000168807273283149945470000012964374496046878374_)"
    },
    points: "1597.1,1848.1 1724.1,2094.9  1749.3,2094.9 1609.6,1837.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053533739206589140210000010232619538250846122_",
    gradientUnits: "userSpaceOnUse",
    x1: -462.7029,
    y1: -10.8207,
    x2: -588.1875,
    y2: -226.4976,
    gradientTransform: "matrix(0.4603 0.8878 0.8878 -0.4603 1792.8994 2226.1604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000053533739206589140210000010232619538250846122_)"
    },
    d: "M1609.9,1853.7 c-5.8,3-12.9,0.7-15.9-5l-22.4-43.2c-3-5.8-0.7-12.9,5-15.9l0.5-0.2c5.8-3,12.9-0.7,15.9,5l22.4,43.2c3,5.8,0.7,12.9-5,15.9 L1609.9,1853.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025425553938980300000000013702422764042528672_",
    gradientUnits: "userSpaceOnUse",
    x1: -380.0264,
    y1: -97.3292,
    x2: -559.7063,
    y2: 14.9513,
    gradientTransform: "matrix(0.4603 0.8878 0.8878 -0.4603 1792.8994 2226.1604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025425553938980300000000013702422764042528672_)"
    },
    d: "M1612.2,1782.2l-39-122.6l-93.8,48.6 l68.4,107.6c7.3,9.4,20.6,12.9,31.1,7.4l21.4-11.1C1611,1806.6,1615.8,1793.6,1612.2,1782.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1589.5,1810c-5.7,3.2-12.8,1.2-16.1-4.4l-39.3-69.3c-3.2-5.7-1.2-12.8,4.4-16.1l0.5-0.3 c5.7-3.2,12.8-1.2,16.1,4.4l39.3,69.3c3.2,5.7,1.2,12.8-4.4,16.1L1589.5,1810z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035507573241755549530000018158681598117739141_",
    gradientUnits: "userSpaceOnUse",
    x1: 1415.1564,
    y1: 923.3571,
    x2: 1411.3912,
    y2: 864.9979,
    gradientTransform: "matrix(1 0 0 -1 -419.0844 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035507573241755549530000018158681598117739141_)"
    },
    d: "M1495.5,2891.5H481 c-9.1,0-16.4,7.4-16.4,16.4c0,9.1,7.4,16.4,16.4,16.4h1014.5c9.1,0,16.4-7.4,16.4-16.4 C1511.9,2898.9,1504.6,2891.5,1495.5,2891.5z"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1495.5,2927.8H481c-10.9,0-19.8-8.9-19.8-19.8c0-10.9,8.9-19.8,19.8-19.8h1014.5 c10.9,0,19.8,8.9,19.8,19.8C1515.3,2918.9,1506.4,2927.8,1495.5,2927.8z M481,2894.9c-7.2,0-13,5.9-13,13.1 c0,7.2,5.9,13.1,13,13.1h1014.5c7.2,0,13.1-5.9,13.1-13.1s-5.9-13.1-13.1-13.1H481z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111190870466396567370000012696468851745329313_",
    gradientUnits: "userSpaceOnUse",
    x1: 1416.6318,
    y1: 1084.5525,
    x2: 1403.4537,
    y2: 798.4048,
    gradientTransform: "matrix(1 0 0 -1 -419.0844 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111190870466396567370000012696468851745329313_)"
    },
    d: "M1351.8,2724.6H624.7 c-21.9,0-39.7,17.8-39.7,39.7v127.3h806.5v-127.3C1391.5,2742.4,1373.7,2724.6,1351.8,2724.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179622440594603342730000009132695251431468176_",
    gradientUnits: "userSpaceOnUse",
    x1: 1414.9329,
    y1: 1162.3438,
    x2: 1403.6373,
    y2: 923.2588,
    gradientTransform: "matrix(1 0 0 -1 -419.0844 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179622440594603342730000009132695251431468176_)"
    },
    d: "M1298,2653.7H678.5 c-21.9,0-39.7,17.8-39.7,39.7v31.2h698.9v-31.2C1337.7,2671.4,1319.9,2653.7,1298,2653.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127035441109435802160000003799906796195816886_",
    gradientUnits: "userSpaceOnUse",
    x1: 1420.0754,
    y1: 1329.8964,
    x2: 1403.109,
    y2: 1098.0214,
    gradientTransform: "matrix(1 0 0 -1 -419.0844 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127035441109435802160000003799906796195816886_)"
    },
    d: "M1174.9,2653.7H801.6v-198.6 c0-5.9,4.7-10.6,10.6-10.6h352c5.8,0,10.6,4.7,10.6,10.6L1174.9,2653.7L1174.9,2653.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032627801002084502600000001206809239831616642_",
    gradientUnits: "userSpaceOnUse",
    x1: 1188.6232,
    y1: 1099.0748,
    x2: 1128.7306,
    y2: 841.8888,
    gradientTransform: "matrix(1 0 0 -1 -419.0844 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 687,
    y: 2759.2,
    style: {
      fill: "url(#SVGID_00000032627801002084502600000001206809239831616642_)"
    },
    width: 65.2,
    height: 132.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007414080588941899970000011962961880268843154_",
    gradientUnits: "userSpaceOnUse",
    x1: 1254.0261,
    y1: 1083.8434,
    x2: 1194.1337,
    y2: 826.6576,
    gradientTransform: "matrix(1 0 0 -1 -419.0844 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 775.5,
    y: 2759.2,
    style: {
      fill: "url(#SVGID_00000007414080588941899970000011962961880268843154_)"
    },
    width: 26.2,
    height: 132.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075847261759468410350000004362984455802826397_",
    gradientUnits: "userSpaceOnUse",
    x1: 1289.0283,
    y1: 1075.693,
    x2: 1229.1356,
    y2: 818.5073,
    gradientTransform: "matrix(1 0 0 -1 -419.0844 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 812.3,
    y: 2759.2,
    style: {
      fill: "url(#SVGID_00000075847261759468410350000004362984455802826397_)"
    },
    width: 26.2,
    height: 132.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019647143299751972480000007159985619345108627_",
    gradientUnits: "userSpaceOnUse",
    x1: 1324.0394,
    y1: 1067.5398,
    x2: 1264.1469,
    y2: 810.3538,
    gradientTransform: "matrix(1 0 0 -1 -419.0844 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 849.3,
    y: 2759.2,
    style: {
      fill: "url(#SVGID_00000019647143299751972480000007159985619345108627_)"
    },
    width: 26.2,
    height: 132.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128458869990703089270000002653264643746964408_",
    gradientUnits: "userSpaceOnUse",
    x1: -736.0031,
    y1: 4283.8892,
    x2: -654.061,
    y2: 4283.8892,
    gradientTransform: "matrix(0.9057 -0.4241 -0.4241 -0.9057 3171.2751 5702.083)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000128458869990703089270000002653264643746964408_)"
    },
    d: "M558.1,1736.6 c-11.2,5.2-16.2,18.4-11.3,29.8L854,2489c5.1,11.8,19,17.1,30.7,11.6l53.5-25.1L586,1723.5L558.1,1736.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042727001965199567700000017349986618047162509_",
    gradientUnits: "userSpaceOnUse",
    x1: -680.5676,
    y1: 4353.2725,
    x2: -481.869,
    y2: 4353.2725,
    gradientTransform: "matrix(0.9057 -0.4241 -0.4241 -0.9057 3171.2751 5702.083)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042727001965199567700000017349986618047162509_)"
    },
    d: "M682.6,1575 c-11.1-22.5-38.2-32-60.9-21.4l-56.4,26.4c-22.7,10.7-32.8,37.5-22.6,60.5l371.5,846.3l157.3-73.6c12.8-6,18.1-21.3,11.8-33.9 L682.6,1575z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095322303297650164040000012530202881763816872_",
    gradientUnits: "userSpaceOnUse",
    x1: -440.0358,
    y1: 4771.3135,
    x2: -623.3297,
    y2: 4236.2427,
    gradientTransform: "matrix(0.9057 -0.4241 -0.4241 -0.9057 3171.2751 5702.083)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095322303297650164040000012530202881763816872_)"
    },
    d: "M680.3,1727l-5.9,2.8 c-18.3,8.6-26.1,30.3-17.6,48.6l201.3,430c8.5,18.3,30.3,26.1,48.5,17.6l5.9-2.8c18.3-8.6,26.1-30.3,17.6-48.6l-201.3-430 C720.3,1726.3,698.6,1718.4,680.3,1727z"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 784.3,
    y: 1702.5,
    transform: "matrix(0.9057 -0.424 0.424 0.9057 -763.165 522.9028)",
    className: "st28",
    width: 18.3,
    height: 547.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142885760412581338850000003466722916205960596_",
    gradientUnits: "userSpaceOnUse",
    x1: 709.0587,
    y1: 1903.9701,
    x2: 1027.2512,
    y2: 1136.2671,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000142885760412581338850000003466722916205960596_)"
    },
    cx: 975.6,
    cy: 2449.1,
    r: 162.8
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -1446.0264 1407.1476)",
    className: "st28",
    cx: 975.6,
    cy: 2449.1,
    rx: 124.4,
    ry: 124.4
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070833308757653701820000011892260870627233961_",
    gradientUnits: "userSpaceOnUse",
    x1: -907.5521,
    y1: 5000.3091,
    x2: -884.9645,
    y2: 5158.4224,
    gradientTransform: "matrix(0.963 -0.2699 -0.2699 -0.963 3162.3171 6221.3379)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070833308757653701820000011892260870627233961_)"
    },
    d: "M594.1,1576.5l12.8,45.7 c2.8,10,13.3,15.7,23.2,12.6l600.6-191.9c9.5-3,14.9-12.9,12.2-22.5l-6.7-23.8L594.1,1576.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016045764395124157740000006930385871894679732_",
    gradientUnits: "userSpaceOnUse",
    x1: -1219.2775,
    y1: 5223.4702,
    x2: -441.066,
    y2: 5223.4702,
    gradientTransform: "matrix(0.963 -0.2699 -0.2699 -0.963 3162.3171 6221.3379)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016045764395124157740000006930385871894679732_)"
    },
    d: "M1320.9,1285.9l13.5,48.2 c5.4,19.4-5.7,39.6-24.9,45.5L599.9,1597l-37.6-134.3c-3-10.9,3.5-22.2,14.4-24.9L1276,1260 C1295.5,1254.9,1315.5,1266.4,1320.9,1285.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074424255968536466160000000254976916849361033_",
    gradientUnits: "userSpaceOnUse",
    x1: -812.4288,
    y1: 5382.3584,
    x2: -859.1464,
    y2: 5108.7271,
    gradientTransform: "matrix(0.963 -0.2699 -0.2699 -0.963 3162.3171 6221.3379)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000074424255968536466160000000254976916849361033_)"
    },
    d: "M1126.6,1326.8l-383.8,107.6 c-17,4.8-26.9,22.4-22.1,39.4s22.4,26.9,39.4,22.1l383.9-107.6c17-4.8,26.9-22.4,22.1-39.4S1143.6,1322.1,1126.6,1326.8z"
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 712.1,
    y: 1403.9,
    transform: "matrix(0.9629 -0.2699 0.2699 0.9629 -345.904 306.9713)",
    className: "st28",
    width: 462.5,
    height: 14.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155122191347886813300000003548936183938157494_",
    gradientUnits: "userSpaceOnUse",
    x1: -1343.5175,
    y1: 5201.2266,
    x2: -1081.9989,
    y2: 5201.2266,
    gradientTransform: "matrix(0.963 -0.2699 -0.2699 -0.963 3162.3171 6221.3379)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000155122191347886813300000003548936183938157494_)"
    },
    cx: 590.6,
    cy: 1539.9,
    r: 130.7
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M563.7,1443.7c-53.1,14.9-84.1,70-69.2,123.1s70,84.1,123.1,69.2c53.1-14.9,84.1-70,69.2-123.1 C671.9,1459.8,616.8,1428.8,563.7,1443.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181052645849368853500000002603561385875390854_",
    gradientUnits: "userSpaceOnUse",
    x1: 1069.6764,
    y1: 1000.4241,
    x2: 1530.7201,
    y2: 1000.4241,
    gradientTransform: "matrix(0.4215 0.9069 0.9069 -0.4215 -36.5273 701.7554)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181052645849368853500000002603561385875390854_)"
    },
    d: "M1534,1659.9l-35.6,16.6 c-14.4,6.7-30.1,3.5-35.4-7.2l-198.1-392.7l99.2-46.1c8.1-3.7,16.8-1.8,19.5,4.4l167.7,393.3 C1556,1639.1,1548.3,1653.2,1534,1659.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094579755321978663110000006105147276418073224_",
    gradientUnits: "userSpaceOnUse",
    x1: 1121.1501,
    y1: 1480.9882,
    x2: 786.076,
    y2: 1162.8557,
    gradientTransform: "matrix(0.5256 0.8508 0.8508 -0.5256 -319.4513 1178.4728)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000094579755321978663110000006105147276418073224_)"
    },
    d: "M1413.4,1246.2 c-29.8-48.2-93-63.2-141.2-33.4s-63.2,93-33.4,141.2s93,63.2,141.2,33.4S1443.2,1294.5,1413.4,1246.2z"
  }), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st28",
    cx: 1326.1,
    cy: 1300.3,
    rx: 78.4,
    ry: 78.4
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045597070603801042630000000084217139948701594_",
    gradientUnits: "userSpaceOnUse",
    x1: 1213.8978,
    y1: 1166.7903,
    x2: 1528.0408,
    y2: 1441.3904,
    gradientTransform: "matrix(0.5256 0.8508 0.8508 -0.5256 -319.4513 1178.4728)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045597070603801042630000000084217139948701594_)"
    },
    d: "M1602.5,1649.4l-23-36.8 c-0.5-0.9-1.7-1.1-2.5-0.6l-111.2,69.3c-0.9,0.5-1.1,1.7-0.6,2.5l23,36.8c0.5,0.9,1.7,1.1,2.5,0.6l111.2-69.3 C1602.8,1651.4,1603,1650.3,1602.5,1649.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107586432181759846360000001411987595774615966_",
    gradientUnits: "userSpaceOnUse",
    x1: 1634.9034,
    y1: 1059.7788,
    x2: 1510.363,
    y2: 913.3895,
    gradientTransform: "matrix(0.4215 0.9069 0.9069 -0.4215 -36.5273 701.7554)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000107586432181759846360000001411987595774615966_)"
    },
    d: "M1467.1,1718.5l-19,8.9 c-3.4,1.6-4.8,5.9-3.1,9.6l16.6,35.2c1.7,3.7,5.9,5.3,9.3,3.7l151.6-71.2c3.4-1.6,4.8-5.9,3.1-9.6l-16.6-35.2 c-1.7-3.7-5.9-5.3-9.3-3.7l-17.4,8.2L1467.1,1718.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(4.160142e-02 -0.9991 0.9991 4.160142e-02 1182.952 3561.3037)",
    className: "st17",
    cx: 2447.8,
    cy: 1164,
    rx: 42.4,
    ry: 42.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 1952.8,
    cy: 1305.5,
    rx: 42.4,
    ry: 42.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2117.9,1313.7h-173.2v-16.8h173.2c2.9,0,7.2-0.6,10.5-3.5l154.6-132.5c6.6-5.7,14.2-8.8,21.5-8.8h135.2 v16.8h-135.2c-3.2,0-7,1.7-10.5,4.7l-154.6,132.5C2133.6,1311.1,2126.2,1313.7,2117.9,1313.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 1740.6,
    cy: 1494.4,
    r: 41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 2457.9,
    cy: 1346.2,
    r: 41
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2058.2,1505.7h-322.4c-4.7,0-8.4-3.8-8.4-8.4s3.8-8.4,8.4-8.4h319.6l204.3-149.9c1.4-1.1,3.2-1.6,5-1.6 h195.1c4.6,0,8.4,3.8,8.4,8.4s-3.8,8.4-8.4,8.4h-192.3l-204.3,149.9C2061.8,1505.1,2060,1505.7,2058.2,1505.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085242394261835599740000000181558840064714369_",
    gradientUnits: "userSpaceOnUse",
    x1: 1953.2089,
    y1: 1768.5334,
    x2: 1962.9429,
    y2: 1216.1256,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085242394261835599740000000181558840064714369_)"
    },
    d: "M2584.1,2196.5l86.1,69 c23.9,19.2,11.2,60.1-18.5,60l-1415.1-8.3l383.1-228.8h661.6C2390.3,2088.4,2496.5,2126.3,2584.1,2196.5z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2651.8,2328.9c-0.1,0-0.1,0-0.2,0l-1427.1-8.4l394.2-235.4h662.5c109.1,0,217.4,38.6,304.9,108.8l86.1,69 c12.5,10,17,26.7,11.5,42.4C2678.6,2319.9,2666.3,2328.9,2651.8,2328.9z M1248.7,2313.9l1403,8.3c0.1,0,0.1,0,0.1,0 c13.9,0,22.3-9.9,25.6-19.1c3.5-9.9,3.1-24.9-9.3-34.9l-86.1-69c-86.4-69.2-193.2-107.4-300.7-107.4h-660.7L1248.7,2313.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024680069595360423280000008045436699329046945_",
    gradientUnits: "userSpaceOnUse",
    x1: -1955.2933,
    y1: 1576.9263,
    x2: -1895.2958,
    y2: 428.3882,
    gradientTransform: "matrix(-1 0 0 -1 -113.6821 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024680069595360423280000008045436699329046945_)"
    },
    d: "M476.4,2812.1 c1.2-11.6,2.5-23.2,3.8-34.7c13.1-118.1,73.4-224.1,165.1-290l7.1-5.1c110.5-79.4,237.4-128.3,369.5-142.3l214.7-22.7 l1415.1,8.3c29.8,0.1,42.4-40.8,18.5-60l-86.1-69c-87.6-70.2-193.8-108.1-302.9-108.1h-661.6l5-2.2 c39.8-17.9,82.4-27.1,125.5-27.1h623c37.9,0,75.5,6.1,111.7,18.1l468.6,187.1c23.2,7.7,43.8,22.3,59.6,42.1l96.8,121.2 c20.1,25.2,31.2,57.4,31.2,90.7v197.5c0,52.3-171.4,230.9-171.4,230.9c-18.7,10.2-39.3,15.6-60.3,15.6H804.3l-223.6-15.7 C516.7,2942.2,469.1,2880.8,476.4,2812.1z"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2909.4,2969.1H804.3c-0.2,0-0.3,0-0.5,0l-223.6-15.7c-31.2-2.2-59.9-17.1-80.8-42.1 c-22.8-27.2-33.6-63.6-29.8-100c1.2-11.6,2.5-23.2,3.8-34.8c13.3-120.2,74.5-227.6,167.8-294.8l7.1-5.1 c111-79.9,239.9-129.5,372.7-143.5l214.7-22.7c0.2,0,0.5-0.1,0.8,0l1415.1,8.3c0,0,0.1,0,0.1,0c12.1,0,19.5-8.7,22.4-16.9 c3.1-8.8,2.8-22.2-8.3-31.1l-86.1-69c-85.8-68.8-191.8-106.6-298.6-106.6h-661.6c-3.2,0-5.9-2.2-6.6-5.3 c-0.7-3.1,0.9-6.2,3.8-7.6l5-2.2c40.8-18.4,84-27.7,128.2-27.7h623c38.6,0,76.9,6.2,113.8,18.5c0.1,0,0.2,0.1,0.4,0.1l468.4,187 c24.4,8.1,46,23.4,62.6,44.2l96.8,121.2c21.1,26.4,32.7,60.1,32.7,94.9v197.5c0,53.4-155.5,217.1-173.2,235.6 c-0.5,0.5-1,0.9-1.6,1.2C2953.4,2963.4,2931.4,2969.1,2909.4,2969.1z M804.5,2955.6h2104.9c19.4,0,38.8-4.9,56.1-14.3 c47.7-49.8,168.8-185,168.8-225.5v-197.5c0-31.8-10.6-62.5-29.8-86.5l-96.8-121.2c-15-18.8-34.6-32.6-56.5-39.9 c-0.1,0-0.2-0.1-0.4-0.1l-468.4-187c-35.5-11.8-72.3-17.7-109.4-17.7h-623c-32.7,0-64.8,5.3-95.7,15.9h626.9 c109.9,0,218.9,38.9,307.1,109.6l86.1,69c13.7,10.9,18.6,29.1,12.5,46.1c-5.6,15.9-19.1,25.8-35.1,25.8c-0.1,0-0.1,0-0.2,0 l-1414.7-8.3l-214.3,22.7c-130.5,13.8-257.1,62.6-366.3,141.1l-7.1,5.1c-90.2,64.9-149.4,168.9-162.3,285.3 c-1.3,11.5-2.5,23.1-3.8,34.7l0,0c-3.5,32.7,6.2,65.5,26.7,89.9c18.5,22.1,43.9,35.4,71.4,37.3L804.5,2955.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178167776210157790500000008928471311039321005_",
    gradientUnits: "userSpaceOnUse",
    x1: -506.2901,
    y1: 1001.7174,
    x2: -933.5469,
    y2: 532.6978,
    gradientTransform: "matrix(-1 0 0 -1 -113.6821 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178167776210157790500000008928471311039321005_)"
    },
    d: "M483.9,2901.5h6.7 c13,0,23.6-11.4,23.6-25.4v-127.9c0-14.1-10.6-25.4-23.6-25.4l0,0c-12.5,0-22.9,10.5-23.5,24l-6.7,127.9 C459.5,2889.2,470.3,2901.5,483.9,2901.5z"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M490.5,2904.9h-6.7c-7.1,0-13.9-2.9-18.9-8.3c-5.5-5.8-8.4-13.9-8-22.1l6.7-127.9 c0.8-15.2,12.6-27.2,26.9-27.2c14.9,0,27,12.9,27,28.8v127.9C517.5,2892,505.4,2904.9,490.5,2904.9z M490.5,2726.1 c-10.7,0-19.6,9.1-20.2,20.8l-6.7,127.9c-0.3,6.4,1.9,12.7,6.2,17.1c3.8,4,8.8,6.2,14,6.2h6.7c11.1,0,20.2-9.9,20.2-22.1v-127.9 C510.8,2736,501.7,2726.1,490.5,2726.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008128936152106700210000016537215014482391988_",
    gradientUnits: "userSpaceOnUse",
    x1: 359.8481,
    y1: 1332.4185,
    x2: 676.2055,
    y2: 1045.2632,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008128936152106700210000016537215014482391988_)"
    },
    d: "M566.9,2698.2h-70.2 c26.2-85.5,78-160.1,148.6-210.9l7.1-5.1c7.3-5.3,14.7-10.4,22.2-15.4c-14.3,54-32,128-43.7,177.6 C623.5,2676.1,597.1,2698.2,566.9,2698.2z"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M566.9,2701.6h-74.8l1.3-4.4c26.5-86.7,79.7-162.2,149.9-212.6l7.1-5.1c7-5.1,14.3-10.1,22.3-15.4l7.4-5 l-2.3,8.6c-14.2,53.5-31.6,126.1-43.6,177.6C626.4,2678.4,598.7,2701.6,566.9,2701.6z M501.2,2694.8h65.7 c28.7,0,53.7-21,60.7-51.1c11.4-48.8,27.6-116.5,41.4-169.1c-5.1,3.5-9.9,6.9-14.7,10.3l-7.1,5.1 C579.4,2538.8,527.7,2611.4,501.2,2694.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127723808094612553770000016107345920914880643_",
    gradientUnits: "userSpaceOnUse",
    x1: -3216.1289,
    y1: 1411.0868,
    x2: -3071.5679,
    y2: 1192.639,
    gradientTransform: "matrix(-1 0 0 -1 -113.6821 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127723808094612553770000016107345920914880643_)"
    },
    d: "M2953.4,2410.6v-146.3 c23.2,7.7,43.8,22.3,59.6,42.1l96.8,121.2c16.8,21.1,27.2,47,30.2,74.4l-132.1-22.6C2976.5,2474.1,2953.4,2444.9,2953.4,2410.6z "
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M3143.9,2506.1l-136.5-23.3c-33.2-5.7-57.3-36-57.3-72.2v-150.9l4.4,1.5c23.8,7.9,45,22.9,61.2,43.2 l96.8,121.2c17.1,21.4,27.8,47.8,30.9,76.1L3143.9,2506.1z M2956.7,2269.1v141.5c0,32.9,21.8,60.4,51.7,65.6l127.7,21.8 c-3.6-25.4-13.5-48.9-28.9-68.2l-96.8-121.2C2996,2290.5,2977.5,2276.9,2956.7,2269.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161613627441552246930000004169180012382427283_",
    gradientUnits: "userSpaceOnUse",
    x1: 1740.2406,
    y1: 1531.7306,
    x2: 1165.929,
    y2: 1054.7603,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161613627441552246930000004169180012382427283_)"
    },
    d: "M1469.1,2310.7l49.8-52.1 c20.7-21.7,46.8-36.6,75.2-42.7l98.4-21.4c27-5.9,52.8,14.6,55.8,44.1l0.7,6.9c3,30.1-19,56.3-47.1,55.9l-126.8-1.6 c-17.7-0.2-33.8,11.1-40.7,28.6l-2.3,5.9c-3.1,7.8-10.2,12.8-18,12.8h-31.2C1465.1,2347.1,1456.4,2324,1469.1,2310.7z"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1513.9,2350.5h-31.2c-9.1,0-17.1-5.5-20.9-14.3c-4.1-9.5-2.2-20.4,4.8-27.8l49.8-52.1 c21.2-22.3,47.8-37.4,76.9-43.7l98.4-21.4c13.3-2.9,26.8,0,38.1,8.2c12.3,8.9,20.2,23.1,21.8,38.9l0.7,6.9 c1.6,16.1-3.5,32-14.1,43.6c-9.7,10.5-22.6,16.3-36.3,16.1l-126.8-1.6c-0.2,0-0.3,0-0.5,0c-16.1,0-30.7,10.3-37.1,26.5l-2.3,5.9 C1531.5,2344.6,1523.2,2350.5,1513.9,2350.5z M1471.5,2313.1c-5.1,5.4-6.5,13.4-3.5,20.5c2.7,6.4,8.2,10.2,14.7,10.2h31.2 c6.5,0,12.3-4.2,14.9-10.7l2.3-5.9c7.5-18.9,24.8-30.8,43.9-30.7l126.8,1.6c11.8,0.3,22.9-4.8,31.3-13.9 c9.3-10.1,13.8-24.1,12.4-38.3l-0.7-6.9c-1.4-13.9-8.3-26.3-19-34.1c-9.7-7-21.3-9.5-32.7-7.1l-98.4,21.4 c-27.7,6-53.1,20.5-73.4,41.8L1471.5,2313.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167375861873419175140000014677077612743287719_",
    gradientUnits: "userSpaceOnUse",
    x1: 1876.1083,
    y1: 1494.688,
    x2: 1866.3744,
    y2: 1129.6599,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000167375861873419175140000014677077612743287719_)"
    },
    d: "M1978.8,2405.2h-217 c-16.9,0-28.9,18.1-23,35.3c9.9,29,33.6,65.9,89.8,70.2c50.6,3.9,114.3-27,162.3-56.3 C2012.8,2441.1,2003.9,2405.2,1978.8,2405.2z"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1837.4,2514.4c-3,0-6-0.1-9-0.3c-57.6-4.4-82.2-41.9-92.7-72.5c-3.2-9.5-1.8-19.9,4-28 c5.3-7.4,13.4-11.7,22.2-11.7h217c12.6,0,23,8.3,26.6,21.1c3.2,11.3,0.5,26.2-12.7,34.3 C1949.2,2483.8,1888.1,2514.4,1837.4,2514.4z M1761.9,2408.6c-6.6,0-12.6,3.2-16.7,8.9c-4.5,6.3-5.7,14.5-3.1,21.9 c9.8,28.7,32.9,63.8,86.8,68c50.5,3.9,115.1-28.2,160.3-55.9c10.2-6.2,12.2-17.9,9.8-26.7c-2.2-7.9-8.7-16.2-20.1-16.2 L1761.9,2408.6L1761.9,2408.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031165604203654888280000011062989835055397812_",
    gradientUnits: "userSpaceOnUse",
    x1: 2684.8765,
    y1: 1284.438,
    x2: 2558.9495,
    y2: 375.5664,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000031165604203654888280000011062989835055397812_)"
    },
    cx: 2617.7,
    cy: 2910.3,
    r: 286.4
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2617.7,3200.1c-159.8,0-289.8-130-289.8-289.8s130-289.8,289.8-289.8s289.8,130,289.8,289.8 S2777.5,3200.1,2617.7,3200.1z M2617.7,2627.2c-156.1,0-283.1,127-283.1,283.1s127,283.1,283.1,283.1s283.1-127,283.1-283.1 C2900.8,2754.2,2773.8,2627.2,2617.7,2627.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160875742969071017850000002624637403546641796_",
    gradientUnits: "userSpaceOnUse",
    x1: -2502.1643,
    y1: 1175.3375,
    x2: -3137.0681,
    y2: 135.0712,
    gradientTransform: "matrix(-1 0 0 -1 -113.6821 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000160875742969071017850000002624637403546641796_)"
    },
    cx: 2617.7,
    cy: 2910.3,
    r: 232.6
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2617.7,3146.2c-130.1,0-236-105.9-236-236s105.9-236,236-236s236,105.9,236,236 S2747.8,3146.2,2617.7,3146.2z M2617.7,2681c-126.4,0-229.2,102.8-229.2,229.2s102.8,229.2,229.2,229.2s229.2-102.8,229.2-229.2 S2744.1,2681,2617.7,2681z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043450513012796909940000000822262884405686710_",
    gradientUnits: "userSpaceOnUse",
    x1: 1025.7393,
    y1: 1231.4564,
    x2: 823.1588,
    y2: 333.5302,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000043450513012796909940000000822262884405686710_)"
    },
    cx: 928.3,
    cy: 2910.3,
    r: 286.4
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M928.3,3200.1c-159.8,0-289.8-130-289.8-289.8s130-289.8,289.8-289.8s289.8,130,289.8,289.8 S1088.1,3200.1,928.3,3200.1z M928.3,2627.2c-156.1,0-283.1,127-283.1,283.1s127,283.1,283.1,283.1s283.1-127,283.1-283.1 S1084.4,2627.2,928.3,2627.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164488093661570012120000000222489980451422367_",
    gradientUnits: "userSpaceOnUse",
    x1: -793.0928,
    y1: 1224.8352,
    x2: -1427.9979,
    y2: 140.6115,
    gradientTransform: "matrix(-1 0 0 -1 -113.6821 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000164488093661570012120000000222489980451422367_)"
    },
    cx: 928.3,
    cy: 2910.3,
    r: 232.6
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M928.3,3146.2c-130.1,0-236-105.9-236-236s105.9-236,236-236s236,105.9,236,236 C1164.3,3040.4,1058.5,3146.2,928.3,3146.2z M928.3,2681c-126.4,0-229.2,102.8-229.2,229.2s102.8,229.2,229.2,229.2 s229.3-102.8,229.3-229.2C1157.6,2783.9,1054.8,2681,928.3,2681z"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M738.6,2993.8c-1.3,0-2.6-0.8-3.1-2.1c-10.9-25.8-16.5-53.2-16.5-81.5c0-115.4,93.9-209.3,209.3-209.3 c35.8,0,71.1,9.2,102.2,26.6c1.6,0.9,2.2,3,1.3,4.6c-0.9,1.6-3,2.2-4.6,1.3c-30-16.8-64.2-25.7-98.9-25.7 c-111.7,0-202.6,90.9-202.6,202.6c0,27.4,5.4,53.9,15.9,78.9c0.7,1.7-0.1,3.7-1.8,4.4C739.5,2993.7,739,2993.8,738.6,2993.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2271.1,2821.3c-0.2,0-0.4,0-0.6-0.1c-1.8-0.4-3-2.1-2.7-3.9c32.4-170.5,144.2-234.9,232.2-258.9 c95.1-25.9,183.7-11.4,184.6-11.3c1.8,0.3,3.1,2.1,2.8,3.9c-0.3,1.8-2.1,3.1-3.9,2.8c-0.9-0.1-88.2-14.4-181.9,11.2 c-125.2,34.2-201.6,119.6-227.1,253.6C2274.1,2820.2,2272.7,2821.3,2271.1,2821.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1278.2,2865c0,0-0.1,0-0.1,0c-1.9-0.1-3.3-1.6-3.3-3.5c3.2-103.4-24.3-184.2-81.8-240.2 c-95.2-92.7-241.6-85.3-243.1-85.2c-1.8,0.1-3.5-1.3-3.6-3.2c-0.1-1.9,1.3-3.4,3.2-3.6c1.5-0.1,150.9-7.6,248.2,87.1 c58.9,57.4,87.2,139.9,83.9,245.3C1281.5,2863.5,1280,2865,1278.2,2865z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M2642.6,2293c-0.6,0-1.1-0.1-1.7-0.4l-191.9-109.2c-53.5-30.4-114.3-47.1-175.9-48.2l-220.1-3.9 c-1.9,0-3.3-1.6-3.3-3.4c0-1.9,1.6-3.4,3.4-3.3l220.1,3.9c62.7,1.1,124.6,18.1,179.1,49.1l191.9,109.2c1.6,0.9,2.2,3,1.3,4.6 C2644.9,2292.4,2643.8,2293,2642.6,2293z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080195088974698252060000011730652452040430466_",
    gradientUnits: "userSpaceOnUse",
    x1: 2207.896,
    y1: 2540.0281,
    x2: 2002.0719,
    y2: 1012.3588,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000080195088974698252060000011730652452040430466_)"
    },
    points: "2317.2,1678.1 1893.8,2057.9  1918.5,2057.9 2334.2,1675.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146471029706403601450000004652834556190081187_",
    gradientUnits: "userSpaceOnUse",
    x1: 1677.4805,
    y1: 1554.1047,
    x2: 1561.2131,
    y2: 1354.27,
    gradientTransform: "matrix(-0.848 0.53 -0.53 -0.848 4604.0986 2109.6021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146471029706403601450000004652834556190081187_)"
    },
    d: "M2310.6,1688.7 c3.2,5.1,9.9,6.7,15,3.5l38.3-23.9c5.1-3.2,6.7-9.9,3.5-15l-0.3-0.4c-3.2-5.1-9.9-6.7-15-3.5l-38.3,23.9 c-5.1,3.2-6.7,9.9-3.5,15L2310.6,1688.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137816961765608912060000008178867971593186700_",
    gradientUnits: "userSpaceOnUse",
    x1: 1754.088,
    y1: 1473.9512,
    x2: 1587.6139,
    y2: 1577.9792,
    gradientTransform: "matrix(-0.848 0.53 -0.53 -0.848 4604.0986 2109.6021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137816961765608912060000008178867971593186700_)"
    },
    d: "M2342.5,1630.6l88.9-79.3l51.9,83 l-105.3,53.6c-10.2,4-22.5,0.6-28.3-8.8l-11.9-19C2331.9,1650.7,2334.3,1638,2342.5,1630.6z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M2347.5,1663.5c3,5.2,9.7,7,14.9,4l64-36.7c5.2-3,7-9.7,4-14.9l-0.2-0.4c-3-5.2-9.7-7-14.9-4l-64,36.7 c-5.2,3-7,9.7-4,14.9L2347.5,1663.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000195413891510190380000013344104164742480813_",
    gradientUnits: "userSpaceOnUse",
    x1: 3184.9783,
    y1: 2653.4866,
    x2: 3612.1455,
    y2: 2653.4866,
    gradientTransform: "matrix(-0.8244 0.566 -0.566 -0.8244 6952.6582 1728.1521)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000195413891510190380000013344104164742480813_)"
    },
    d: "M2462.6,1570l20.6,30 c8.3,12.1,22.4,16.9,31.7,10.9l343.1-219.7l-57.4-83.6c-4.7-6.8-12.6-9.3-17.6-5.7l-319.2,234.6 C2454.8,1543,2454.2,1557.9,2462.6,1570z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046336711999886308290000000706283522273322921_",
    gradientUnits: "userSpaceOnUse",
    x1: 3455.2209,
    y1: 2510.3044,
    x2: 3746.0156,
    y2: 2764.4951,
    gradientTransform: "matrix(-0.8244 0.566 -0.566 -0.8244 6952.6582 1728.1521)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046336711999886308290000000706283522273322921_)"
    },
    d: "M2417.6,1548.9l33-22.5 c0.8-0.6,2-0.3,2.5,0.5l68.2,100.1c0.6,0.8,0.4,2-0.5,2.5l-33,22.5c-0.8,0.6-2,0.3-2.5-0.5l-68.2-100.1 C2416.6,1550.6,2416.8,1549.5,2417.6,1548.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115484313422432244400000002006080497570536372_",
    gradientUnits: "userSpaceOnUse",
    x1: 3708.6814,
    y1: 2708.4175,
    x2: 3593.2812,
    y2: 2572.772,
    gradientTransform: "matrix(-0.8244 0.566 -0.566 -0.8244 6952.6582 1728.1521)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115484313422432244400000002006080497570536372_)"
    },
    d: "M2488.2,1648.2l10.9,16.1 c2,2.9,1.1,7-2,9.1l-29.8,20.3c-3.1,2.1-7.2,1.5-9.2-1.4l-87.3-128.2c-2-2.9-1.1-7,2-9.1l29.8-20.3c3.1-2.1,7.2-1.5,9.2,1.4 l10,14.7L2488.2,1648.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048469308750649376300000006744393104870597528_",
    gradientUnits: "userSpaceOnUse",
    x1: 1683.6442,
    y1: 597.6512,
    x2: 1680.1559,
    y2: 543.5826,
    gradientTransform: "matrix(-1 0 0 -1 4371.918 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000048469308750649376300000006744393104870597528_)"
    },
    d: "M2225.6,3209.5h939.9 c8.4,0,15.2,6.8,15.2,15.2s-6.8,15.2-15.2,15.2h-939.9c-8.4,0-15.2-6.8-15.2-15.2C2210.4,3216.3,2217.2,3209.5,2225.6,3209.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114055033038679142150000011997003735751035309_",
    gradientUnits: "userSpaceOnUse",
    x1: 1685.0264,
    y1: 746.9944,
    x2: 1672.8173,
    y2: 481.885,
    gradientTransform: "matrix(-1 0 0 -1 4371.918 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114055033038679142150000011997003735751035309_)"
    },
    d: "M2358.7,3054.9h673.6 c20.3,0,36.8,16.5,36.8,36.8v117.9h-747.2v-117.9C2321.9,3071.3,2338.4,3054.9,2358.7,3054.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167389896250074656180000017158367034348846214_",
    gradientUnits: "userSpaceOnUse",
    x1: 1683.4376,
    y1: 819.0669,
    x2: 1672.9727,
    y2: 597.5603,
    gradientTransform: "matrix(-1 0 0 -1 4371.918 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000167389896250074656180000017158367034348846214_)"
    },
    d: "M2408.5,2989.1h574 c20.3,0,36.8,16.5,36.8,36.8v28.9h-647.5v-28.9C2371.8,3005.6,2388.2,2989.1,2408.5,2989.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038397984924412866960000012119261826567892362_",
    gradientUnits: "userSpaceOnUse",
    x1: 2868.7971,
    y1: 1479.5663,
    x2: 2801.7854,
    y2: 1221.8285,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000038397984924412866960000012119261826567892362_)"
    },
    d: "M2522.6,2989.1h345.8v-183.2 c0-5.9-4.7-10.6-10.6-10.6h-324.6c-5.9,0-10.6,4.7-10.6,10.6L2522.6,2989.1L2522.6,2989.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006675092602903849860000015044327899901771672_",
    gradientUnits: "userSpaceOnUse",
    x1: 1473.761,
    y1: 760.4512,
    x2: 1418.2719,
    y2: 522.1738,
    gradientTransform: "matrix(-1 0 0 -1 4371.918 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000006675092602903849860000015044327899901771672_)"
    },
    points: "2914.2,3209.5 2974.6,3209.5  2974.6,3087 2914.2,3087  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001640825592926456410000013592540730487865990_",
    gradientUnits: "userSpaceOnUse",
    x1: 1534.3597,
    y1: 746.3389,
    x2: 1478.8706,
    y2: 508.0618,
    gradientTransform: "matrix(-1 0 0 -1 4371.918 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000001640825592926456410000013592540730487865990_)"
    },
    points: "2868.4,3209.5 2892.7,3209.5  2892.7,3087 2868.4,3087  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135670741732773685540000012590986714629450629_",
    gradientUnits: "userSpaceOnUse",
    x1: 1566.7958,
    y1: 738.7858,
    x2: 1511.3065,
    y2: 500.5087,
    gradientTransform: "matrix(-1 0 0 -1 4371.918 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000135670741732773685540000012590986714629450629_)"
    },
    points: "2834.2,3209.5 2858.5,3209.5  2858.5,3087 2834.2,3087  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093896945930630618540000001863917947870031500_",
    gradientUnits: "userSpaceOnUse",
    x1: 1599.2268,
    y1: 731.2334,
    x2: 1543.7377,
    y2: 492.9561,
    gradientTransform: "matrix(-1 0 0 -1 4371.918 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000093896945930630618540000001863917947870031500_)"
    },
    points: "2800,3209.5 2824.3,3209.5  2824.3,3087 2800,3087  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047750850827925435990000003078529373254208679_",
    gradientUnits: "userSpaceOnUse",
    x1: -821.1484,
    y1: 2864.0227,
    x2: -745.2424,
    y2: 2864.0227,
    gradientTransform: "matrix(-0.8522 -0.5233 0.5233 -0.8522 798.6208 4528.9795)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047750850827925435990000003078529373254208679_)"
    },
    d: "M3158.1,2165.4 c9.8,6,13,18.7,7.3,28.6l-358.1,633.2c-5.9,10.4-19.3,13.8-29.4,7.5l-46.6-28.6l402.6-655.6L3158.1,2165.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044876015695843089990000016509684556663076285_",
    gradientUnits: "userSpaceOnUse",
    x1: -769.7996,
    y1: 2928.2996,
    x2: -585.7088,
    y2: 2928.2996,
    gradientTransform: "matrix(-0.8522 -0.5233 0.5233 -0.8522 798.6208 4528.9795)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044876015695843089990000016509684556663076285_)"
    },
    d: "M3060.3,2003.6 c12.6-19.6,38.5-25.5,58.3-13.3l49.2,30.2c19.8,12.2,26.3,38,14.5,58l-430.2,740.4l-137.1-84.2c-11.1-6.8-14.4-21.5-7.3-32.4 L3060.3,2003.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082357043676114211640000009298573880367889037_",
    gradientUnits: "userSpaceOnUse",
    x1: -546.9351,
    y1: 3315.6221,
    x2: -716.7584,
    y2: 2819.8743,
    gradientTransform: "matrix(-0.8522 -0.5233 0.5233 -0.8522 798.6208 4528.9795)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082357043676114211640000009298573880367889037_)"
    },
    d: "M3046.6,2143.8l5.1,3.2 c15.9,9.8,20.9,30.6,11.1,46.5l-230.2,374.8c-9.8,15.9-30.6,20.9-46.5,11.1l-5.1-3.2c-15.9-9.8-20.9-30.6-11.1-46.5 l230.2-374.8C3009.8,2139,3030.6,2134,3046.6,2143.8z"
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2662.5,
    y: 2353.2,
    transform: "matrix(0.5232 -0.8522 0.8522 0.5232 -622.2018 3611.2759)",
    className: "st28",
    width: 507.5,
    height: 17
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082336144677266375310000007592922682015233197_",
    gradientUnits: "userSpaceOnUse",
    x1: -854.2702,
    y1: 2486.8718,
    x2: -552.5807,
    y2: 2486.8718,
    gradientTransform: "matrix(-0.8522 -0.5233 0.5233 -0.8522 798.6208 4528.9795)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000082336144677266375310000007592922682015233197_)"
    },
    cx: 2699.5,
    cy: 2777.8,
    r: 150.8
  }), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st28",
    cx: 2699.4,
    cy: 2777.8,
    rx: 115.2,
    ry: 115.2
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106120960136253979060000017804387709687334331_",
    gradientUnits: "userSpaceOnUse",
    x1: 2233.8857,
    y1: 2599.6719,
    x2: 2254.8159,
    y2: 2746.1821,
    gradientTransform: "matrix(-0.4967 -0.868 0.868 -0.4967 1683.8524 5073.1279)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106120960136253979060000017804387709687334331_)"
    },
    d: "M3106.7,2017.8l-38.1,21.8 c-8.3,4.8-18.9,1.7-23.4-6.8l-271.7-517.1c-4.3-8.1-1.4-18.2,6.6-22.8l19.9-11.4L3106.7,2017.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093874584972378522130000009135516802955358108_",
    gradientUnits: "userSpaceOnUse",
    x1: 1945.0754,
    y1: 2806.449,
    x2: 2666.0923,
    y2: 2806.449,
    gradientTransform: "matrix(-0.4967 -0.868 0.868 -0.4967 1683.8524 5073.1279)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093874584972378522130000009135516802955358108_)"
    },
    d: "M2815.9,1353.4l-40.2,23 c-16.2,9.3-22,29.8-13.1,46.2l326.9,604.9l112.1-64.2c9.1-5.2,12.1-16.9,6.7-25.8l-346-572 C2852.8,1349.5,2832.1,1344.1,2815.9,1353.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032641619838051199240000003846986025514756539_",
    gradientUnits: "userSpaceOnUse",
    x1: 2322.0125,
    y1: 2953.6741,
    x2: 2278.7244,
    y2: 2700.1292,
    gradientTransform: "matrix(-0.4967 -0.868 0.868 -0.4967 1683.8524 5073.1279)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032641619838051199240000003846986025514756539_)"
    },
    d: "M2917.5,1506.7l183.4,320.6 c8.1,14.2,3.2,32.3-11,40.4c-14.2,8.1-32.3,3.2-40.4-11l-183.4-320.6c-8.1-14.2-3.2-32.3,11-40.4 C2891.3,1487.6,2909.4,1492.6,2917.5,1506.7z"
  }), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2976.8,
    y: 1467.7,
    transform: "matrix(0.868 -0.4966 0.4966 0.868 -441.3444 1703.6855)",
    className: "st28",
    width: 13.7,
    height: 428.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129903803333739503380000011413575809064608436_",
    gradientUnits: "userSpaceOnUse",
    x1: 1829.9781,
    y1: 2785.8345,
    x2: 2072.2432,
    y2: 2785.8345,
    gradientTransform: "matrix(-0.4967 -0.868 0.868 -0.4967 1683.8524 5073.1279)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000129903803333739503380000011413575809064608436_)"
    },
    cx: 3132.8,
    cy: 1995.8,
    r: 121.1
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M3213.1,1949.9c25.4,44.3,10,100.9-34.4,126.3s-100.9,10-126.3-34.3c-25.4-44.3-10-100.9,34.4-126.3 S3187.8,1905.5,3213.1,1949.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036961320131106231880000013471522225368342968_",
    gradientUnits: "userSpaceOnUse",
    x1: 3175.6982,
    y1: 2436.5073,
    x2: 2865.2551,
    y2: 2141.7603,
    gradientTransform: "matrix(-0.8544 0.5197 -0.5197 -0.8544 6588.1348 1765.8508)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036961320131106231880000013471522225368342968_)"
    },
    d: "M2750,1294.6 c44.9-27.3,103.4-13,130.6,31.8c27.3,44.9,13,103.3-31.8,130.6s-103.4,13-130.6-31.8C2690.9,1380.3,2705.1,1321.8,2750,1294.6z"
  }), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -152.914 2382.4087)",
    className: "st28",
    cx: 2799.4,
    cy: 1375.8,
    rx: 72.6,
    ry: 72.6
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093872997321481704210000004108596484497825726_",
    gradientUnits: "userSpaceOnUse",
    x1: 1376.0894,
    y1: 588.0313,
    x2: 961.2891,
    y2: 136.8445,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093872997321481704210000004108596484497825726_)"
    },
    d: "M1245,3155.6c0,0-4.3,24.3-6.4,48.4 c-0.8,9.4,6.4,17.6,15.9,18c32.1,1.3,100.6,3.9,125.2,2.8c3.7-0.2,6.1-3.9,4.8-7.4c-1.2-2.9-3.4-5.2-6.2-6.5l-113.3-52.1 L1245,3155.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078035961158089849460000008210022207638460853_",
    gradientUnits: "userSpaceOnUse",
    x1: 1241.45,
    y1: 554.5181,
    x2: 1278.2899,
    y2: 554.5181,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4421B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C0E16"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078035961158089849460000008210022207638460853_)"
    },
    d: "M1241.4,3141.3l3.4,29.1 c0,0,19.8,9.2,33.4-1.2l-8.2-32.4L1241.4,3141.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150800460243613892240000014152158584677511359_",
    gradientUnits: "userSpaceOnUse",
    x1: 1154.0956,
    y1: 836.2521,
    x2: 1275.9197,
    y2: 836.2521,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150800460243613892240000014152158584677511359_)"
    },
    d: "M1244.1,2594.4 c-1.5,7.6-8,379.1,31.7,545.6c0.7,2.7-0.7,5.5-3.3,6.6c-6.1,2.5-18,6.1-32.3,6.6c-4.4,0.1-8.4-2.7-9.7-7 c-11.3-38.6-65.7-232.1-72.8-417c-7.9-206.6,0-7,0-7l4.7-127.7L1244.1,2594.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097491581006148787370000014393433932867966114_",
    gradientUnits: "userSpaceOnUse",
    x1: 1283.0374,
    y1: 673.5787,
    x2: 868.2375,
    y2: 222.3927,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097491581006148787370000014393433932867966114_)"
    },
    d: "M1114.7,3168.3c0,0-6.8,12.3-13.5,44.9 c-1.2,5.9,2.9,11.5,8.9,12.1c10.6,1,26.9,2.4,39.9,2.3c6,0,10.7-5.3,10-11.3c-1.4-11.9-5.9-31.4-19.9-46.7L1114.7,3168.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064319930013097051810000013197335560607670415_",
    gradientUnits: "userSpaceOnUse",
    x1: 1108.67,
    y1: 556.413,
    x2: 1140.4801,
    y2: 556.413,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4421B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C0E16"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000064319930013097051810000013197335560607670415_)"
    },
    d: "M1108.7,3130.9l8.1,44 c0,0,8,5.9,23.8,1.6l-3.8-47.3L1108.7,3130.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100347795146918093950000004524113642258009535_",
    gradientUnits: "userSpaceOnUse",
    x1: 1074.3754,
    y1: 840.2361,
    x2: 1247.3199,
    y2: 840.2361,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100347795146918093950000004524113642258009535_)"
    },
    d: "M1086.9,2605.8 c-32.5,196,7,484.4,20.4,540.9c0.8,3.5,3.6,6.1,7.1,6.7c5.9,1,15.8,1.8,25.4-1c3.3-1,5.7-4,5.8-7.4 c1.8-45.6-1.4-325.8,28.8-436.6c1.5-5.6,5-10.5,9.7-13.9l58.7-41.8l4.5-67.5L1086.9,2605.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078013294670643543610000017106573849986061974_",
    gradientUnits: "userSpaceOnUse",
    x1: 1309.1736,
    y1: 1129.7021,
    x2: 1588.6578,
    y2: 483.1837,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078013294670643543610000017106573849986061974_)"
    },
    d: "M1293.8,2234.4 c-97.3-1.6-204.7,25.6-204.7,25.6c-29,169.3-5.1,364.5-5.1,364.5c75.3,19.8,160.3-12.1,160.3-12.1 c12.5-70.8,70.9-269.9,70.9-269.9c47.6-5.9,86.7-19.6,119-37.8c-24.6-28.5-36.2-64.8-41.2-86.3 C1358.7,2229.2,1323.8,2234.9,1293.8,2234.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101787118982493088440000016388625498521852557_",
    gradientUnits: "userSpaceOnUse",
    x1: 1393.0701,
    y1: 1515.7471,
    x2: 1581.3,
    y2: 1515.7471,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4421B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C0E16"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101787118982493088440000016388625498521852557_)"
    },
    d: "M1581.3,2091.1 c-9.6-11.6-21.7-6.1-21.7-6.1c-14.3,60.5-89.4,109.6-166.6,133.5c5,21.4,16.6,57.8,41.2,86.3 C1562.3,2232.8,1581.3,2091.1,1581.3,2091.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066486150878300554790000010225305182667072916_",
    gradientUnits: "userSpaceOnUse",
    x1: 11538.4131,
    y1: 1547.3011,
    x2: 11664.7217,
    y2: 1259.9208,
    gradientTransform: "matrix(-1 0 0 -1 13077.7783 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4421B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C0E16"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066486150878300554790000010225305182667072916_)"
    },
    d: "M1579,2094c1,3.2-10.6,8-17.4-5 c-0.2-6.2-4-32.9-0.3-38c19.8-27.1,58.3-60.9,58.3-60.9c6.5,6.4,1.1,12.7,1.1,12.7l-18.7,19.4c3.9,7.1,8.7,13,10.9,21.5 c1.7,6.5,0.7,13.4-2.6,19.2c-3.3,5.9-7.7,13.6-12,19.6C1590.4,2093.9,1579,2094,1579,2094z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043448325584438639730000002561263519379659420_",
    gradientUnits: "userSpaceOnUse",
    x1: 1580.3993,
    y1: 1643.0059,
    x2: 1633.1024,
    y2: 1724.037,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4421B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C0E16"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000043448325584438639730000002561263519379659420_)"
    },
    d: "M1593.9,2034.8l-17,14.4l-5.3,14.4 l15.2,16.8c0,0,5.1-28.5,8.9-34.6C1599.4,2039.6,1597.4,2036.6,1593.9,2034.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159466354595237287700000009767400753640653207_",
    gradientUnits: "userSpaceOnUse",
    x1: 1170.3171,
    y1: 1069.6765,
    x2: 1449.8009,
    y2: 423.1587,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159466354595237287700000009767400753640653207_)"
    },
    d: "M1126.4,2354.2l-37.3-94.2 c0,0-90.9,61.8-105.9,140.1c17.2,1.3,48.4,5.7,79,21.2C1069,2384.3,1126.4,2354.2,1126.4,2354.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026882229110243131770000002144151380156428949_",
    gradientUnits: "userSpaceOnUse",
    x1: 981.1775,
    y1: 1249.1144,
    x2: 1219.39,
    y2: 1249.1144,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4421B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C0E16"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026882229110243131770000002144151380156428949_)"
    },
    d: "M1205.9,2442.9 c0,0-102.1,57.7-136.5,8.4c-7.2-10.2-8.9-20.4-7.1-30.1c-30.6-15.4-61.8-19.9-79-21.2c-4.5,23.6-2.1,48.7,11.8,74.1 c60.3,110.4,224.4-6.1,224.4-6.1L1205.9,2442.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165204981527100842830000011207742980782369927_",
    gradientUnits: "userSpaceOnUse",
    x1: 1291.4554,
    y1: 1418.4818,
    x2: 1422.4381,
    y2: 872.7196,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165204981527100842830000011207742980782369927_)"
    },
    d: "M1193.6,2515.9l55.7-194.5 c0.6-2.2,2.5-3.8,4.8-4.1c10.1-1.2,39.3-4.5,73.1-7.3c40.7-3.4,87.9-6.2,116.1-3.9c4,0.3,6.4,4.6,4.7,8.2 c-16.1,32.5-82.1,164.6-115.1,207.8c-1.1,1.4-2.8,2.3-4.6,2.2l-129.2-1.2C1195.3,2523.1,1192.6,2519.5,1193.6,2515.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116952919901434089450000000094881648487352448_",
    gradientUnits: "userSpaceOnUse",
    x1: 1373.465,
    y1: 1504.5073,
    x2: 1345.5691,
    y2: 1382.0085,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116952919901434089450000000094881648487352448_)"
    },
    d: "M1333,2293.1l40.4-6.7 c2.2-0.4,3.9,1.7,3.2,3.8l-4,12.1c-0.3,1.1-1.3,1.8-2.4,2l-38.9,5.2c-2,0.3-3.7-1.6-3.2-3.5l2.5-10.6 C1330.9,2294.1,1331.8,2293.2,1333,2293.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116956750102533908510000017312959968962778246_",
    gradientUnits: "userSpaceOnUse",
    x1: 1358.865,
    y1: 1453.1234,
    x2: 1345.5234,
    y2: 1373.0743,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116956750102533908510000017312959968962778246_)"
    },
    d: "M1302.8,2327.2l3.3-17.3 c0.3-1.7,1.8-3.1,3.5-3.2l81.6-8.3c2.8-0.3,4.9,2.2,4.3,4.9l-5.2,21.6c-0.4,1.7-1.9,3-3.7,3.1l-79.7,4 C1304.3,2332.1,1302.3,2329.8,1302.8,2327.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173144777049971471280000013268269874375304876_",
    gradientUnits: "userSpaceOnUse",
    x1: 1389.3983,
    y1: 1283.3821,
    x2: 1667.1853,
    y2: 1298.5342,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4421B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C0E16"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173144777049971471280000013268269874375304876_)"
    },
    d: "M1207.1,2468.9c0,0-7.8-31.9-4.6-43.2 s9.2-25.9,29.4-22.6c20.2,3.2,44.1,11.8,44.1,11.8s-1.2,14.7-16.6,10l9.5,7.4c0,0-1.4,11.8-14.3,5.5l8.9,9.8 c0,0-5.6,9.7-15.1,3.5C1238.7,2444.7,1234.2,2472.7,1207.1,2468.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069399880459352431940000015817941031797095328_",
    gradientUnits: "userSpaceOnUse",
    x1: 1164.0913,
    y1: 1503.7815,
    x2: 1258.27,
    y2: 1503.7815,
    gradientTransform: "matrix(1 0 0 -1 0 3710)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4421B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C0E16"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069399880459352431940000015817941031797095328_)"
    },
    d: "M1195.2,2155.4l-31,89.6 c-0.5,1.5,0.1,3.1,1.5,3.9c8.4,4.7,38.8,18.2,75.5-5.1c3.8-2.4,6.4-6.4,7-10.9l10-77.5L1195.2,2155.4L1195.2,2155.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000915408909582074220000013421067078725382586_",
    gradientUnits: "userSpaceOnUse",
    x1: -3623.5508,
    y1: 4612.3081,
    x2: -3658.7446,
    y2: 4728.3862,
    gradientTransform: "matrix(0.746 -0.6659 -0.6659 -0.746 7055.1758 3174.1558)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4421B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C0E16"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000915408909582074220000013421067078725382586_)"
    },
    d: "M1262.6,2072.5c0,0,34,64,29.7,89.9 s-46.5,24-83.3,3l-25.7-69.1L1262.6,2072.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138546516177469064100000003157574046431844743_",
    gradientUnits: "userSpaceOnUse",
    x1: -3655.3157,
    y1: 4814.5537,
    x2: -3625.8762,
    y2: 4646.6396,
    gradientTransform: "matrix(0.746 -0.6659 -0.6659 -0.746 7055.1758 3174.1558)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000138546516177469064100000003157574046431844743_)"
    },
    d: "M1210.6,2131.4 c1.5-0.7,2.1-2.5,1.2-3.9c-2.7-4.2-7.8-12.6-9.5-20.1c0,0-6.1-3.9,15.6-9.1c21.7-5.2,54-13.2,60.8-31.7 c6.6-18-10.8-63.2-38.5-27.2c-1.1,1.4-3.1,1.4-4.2,0c-4.6-5.9-16.5-18.2-33.1-10.8c-15.6,7-17.3,18.4-17.1,24.1 c0.1,1.7-1.4,3-3.1,2.7c-7.9-1.5-26.7-2.8-35.5,16.6c-7.2,15.9-2.5,25,1.8,29.4c1.4,1.4,0.8,3.8-1.1,4.4 c-5.2,1.6-11.8,6-11.2,18.1c0.9,16.7,19.6,15.3,25,14.5c0.9-0.1,1.8,0.2,2.3,0.8c4.6,5.1,25.1,26.5,47.4,29.1 c1.9,0.2,3.4-1.7,2.8-3.5l-9.6-28c-0.4-1.3,0.2-2.7,1.4-3.3L1210.6,2131.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105401560893471808880000001343638868468069769_",
    gradientUnits: "userSpaceOnUse",
    x1: -3659.5293,
    y1: 4612.8472,
    x2: -3691.1943,
    y2: 4717.2856,
    gradientTransform: "matrix(0.746 -0.6659 -0.6659 -0.746 7055.1758 3174.1558)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4421B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C0E16"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105401560893471808880000001343638868468069769_)"
    },
    d: "M1214.5,2135.4c0,0-24.2-16.6-26-2.6 s21.8,20.3,33.5,15.1L1214.5,2135.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomationbremove);
export default __webpack_public_path__ + "static/media/automationbremove.fc9736addfa977a96675b0be102c2533.svg";
export { ForwardRef as ReactComponent };